import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { SearchApiResults } from "./interfaces/search-api-results";
import { ApiMetadata } from "./interfaces/api-metadata";
import { ApiFacetData } from "./interfaces/api-facet-data";
import { QmisApiResults } from "./interfaces/qmis-api-results";

import { LocationZoomSettings } from "../../../map/models/map-settings";
import { transformCommunityApiResults } from "../../../results/functions/wrapping/transform-community-api-results";
import { Result } from "../../../results/models/result";

export interface SearchResults {
	MetaData: ApiMetadata;
	Facets: ApiFacetData;
	Results: Result[];
}

/** The main search API that gets results from SOLR */
export const searchApi = createApi({
	reducerPath: "searchApi",
	baseQuery: fetchBaseQuery({
		baseUrl: window.location.protocol + "//" + window.location.host,
	}),
	endpoints: (builder) => ({
		//The getApiResults query takes two params.
		// path: this is the url path to exactly match, for example /texas/austin
		// mapSettings: these are specific map settings to do a spatial search.
		//If any map settings are passed in the path is ignored.
		getApiResults: builder.query<
			SearchApiResults,
			{ path?: string; mapSettings?: LocationZoomSettings }
		>({
			query: ({ path = "", mapSettings = {} }) => ({
				url:
					Object.keys(mapSettings).length !== 0 && mapSettings?.lat > 0
						? `api/comms/near?lat=${mapSettings.lat}&lng=${mapSettings.lng}&rad=${mapSettings.radius}&zm=${mapSettings.zoom}`
						: `api/comms/direct${path}`,
				method: "GET",
			}),
		}),
		getQmisResults: builder.query<
			QmisApiResults,
			{ path?: string; mapSettings?: LocationZoomSettings }
		>({
			query: ({ path = "", mapSettings = {} }) => ({
				url:
					Object.keys(mapSettings).length !== 0 && mapSettings?.lat > 0
						? `api/qmis/near?lat=${mapSettings.lat}&lng=${mapSettings.lng}&zml=${mapSettings.zoom}&rad=${mapSettings.radius}`
						: `api/qmis/direct${path}`,
				method: "GET",
			}),
		}),
	}),
});
